import item from "@kopapro/components/commons/kppHeaderFooterItem/item";

export default item;